import { wsService } from "./wsService";

import sections from "@/constants/sections";

const section = sections.SECTION_ORG_CHART;

function filter(param = {}) {
  return wsService.make_post_request(section + "/list", param);
}

// param: { assignment: "assigned" | "vacant" | null, sucursal_id }
function tree(param = {}) {
  return wsService.make_post_request(section + "/tree", param);
}

function list_node_types() {
  return wsService.make_post_request(section + "/list-node-types");
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

// param: { id, parent_id, sort_order }
function move(param = {}) {
  return wsService.make_put_request(section + "/move", param);
}

// param: { parent_id, ids: [] }
function reorder(param = {}) {
  return wsService.make_put_request(section + "/reorder", param);
}

// param: { id, legajo_id }
function assign_responsible(param = {}) {
  return wsService.make_put_request(section + "/assign-responsible", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function get(id) {
  return wsService.make_get_request(section + "/get/" + id);
}

function export_filter(param = {}) {
  return wsService.make_post_request(section + "/export", param, {
    responseType: "arraybuffer",
    headers: {
      Accept: "application/vnd.ms-excel",
    },
  });
}

export const orgChartService = {
  section,
  filter,
  tree,
  list_node_types,
  create,
  update,
  move,
  reorder,
  assign_responsible,
  remove,
  get,
  export_filter,
};
